import { BenchmarkModule } from '../models/digital-shelf/benchmark-config.model';

export const toCompactAxisNumber = (value: number): string => {
  const absoluteValue = Math.abs(value);

  if (absoluteValue >= 1_000_000) {
    return `${Number((value / 1_000_000).toFixed(1))}m`;
  }

  if (absoluteValue >= 1_000) {
    return `${Number((value / 1_000).toFixed(1))}k`;
  }

  return value.toLocaleString(undefined, {
    maximumFractionDigits: Number.isInteger(value) ? 0 : 2,
  });
};

export const formatDigitalShelfNumber = (
  value: number | null | undefined,
  options: Intl.NumberFormatOptions = {}
): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return 'N/A';
  }

  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  });
};

export const formatDigitalShelfPercent = (
  value: number | null | undefined,
  options: Intl.NumberFormatOptions = {}
): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return 'N/A';
  }

  return `${formatDigitalShelfNumber(value, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  })}%`;
};

export const formatDigitalShelfSignedPercent = (
  value: number | null | undefined
): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '-';
  }

  return `${value > 0 ? '+' : ''}${formatDigitalShelfPercent(value)}`;
};

export const formatDigitalShelfBenchmarkValue = (
  value: number | null | undefined,
  module?: BenchmarkModule
): string => {
  if (module === undefined) return formatDigitalShelfNumber(value);
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '-';
  }

  switch (module) {
    case 'ratings':
      return formatDigitalShelfNumber(value, { minimumFractionDigits: 2 });
    case 'content_quality':
      return formatDigitalShelfNumber(value, { minimumFractionDigits: 0 });
    // Other modules TBD later
    default:
      return '-';
  }
};
